import {IGlobalLoadingState} from '../state/global-loading.state';
import {GLOBAL_LOADING_ACTION, SetGlobalLoading} from '../action/global-loading.action';

const initialGlobalLoadingState: IGlobalLoadingState = {
  loading: true,
};

export function globalLoadingReducer(
  state: IGlobalLoadingState = initialGlobalLoadingState,
  action: SetGlobalLoading,
): IGlobalLoadingState {
  switch (action.type) {
    case GLOBAL_LOADING_ACTION.INIT_GLOBAL_LOADING:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
